import { useCallback } from "react";

// Custom hook for converting files to Base64
export const useBase64Converter = () => {
  // Function to convert a single file to Base64
  const convertToBase64 = useCallback((file: File) => {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result as string;
        // Check if the file is xlsx or csv and split the Base64 string
        if (
          file.type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
          file.type === "text/csv"
        ) {
          const splitBase64 = base64String.split(",")[1];
          resolve(splitBase64);
        } else {
          resolve(base64String);
        }
      };

      reader.onerror = (error) => reject(error);
    });
  }, []);

  // Function to convert an array of files to Base64
  const convertFilesToBase64 = useCallback(
    (files: File[]) => {
      const filesBase64: string[] = [];
      files.forEach(async (file) => {
        if (file) {
          const base64 = await convertToBase64(file);
          filesBase64.push(base64);
        }
      });
      return filesBase64;
    },
    [convertToBase64]
  );

  return { convertFilesToBase64 };
};
